module.exports = __webpack_public_path__ + "img/VL_19_03.cc672fed.png";